import { Switch, Route } from 'react-router-dom'

import { ApplicationsManager } from 'components/applications/ApplicationsManager'
import { ClaimCompanyManager } from 'components/claim/ClaimCompanyManager'
import { NotFoundPage } from 'components/common/NotFoundPage'
import { ProtectedRoute } from 'components/common/ProtectedRoute'
import { withNavigation } from 'components/common/withNavigation'
import { CompanyManager } from 'components/company/CompanyManager'
import { JobsManager } from 'components/jobs/JobsManager'
import { CompanyManager as LegacyCompanyManager } from 'components/legacy-company/CompanyManager'
import { PilotDetailsManager } from 'components/pilots/PilotDetails/PilotDetailsManager'
import { PilotsManager } from 'components/pilots/PilotsManager'
import { ProductsManager } from 'components/products/ProductsManager'
import { StaffManager } from 'components/staff/StaffManager'
import { RESOURCES } from 'constants/resources'
import { ROLES } from 'constants/roles'
import { usePermissions } from 'lib/permissions'

const resourceToPage = {
  [RESOURCES.PILOT_APPLICATION]: ApplicationsManager,
  [RESOURCES.PILOT_DETAILS]: PilotsManager,
  [RESOURCES.JOB]: JobsManager,
  [RESOURCES.PRODUCT]: ProductsManager,
  [RESOURCES.STAFF]: StaffManager,
  [RESOURCES.CLAIM_COMPANY]: ClaimCompanyManager,
  [RESOURCES.MY_PILOT_INFO]: PilotDetailsManager,
  [RESOURCES.MY_COMPANY]: CompanyManager,
}

export const getDefaultResource = (role) => {
  if (
    [ROLES.BILLING, ROLES.COMMERCIAL, ROLES.HERO_PILOT, ROLES.KEY_CONTACT].includes(
      role
    )
  ) {
    return RESOURCES.MY_COMPANY
  }

  if ([ROLES.PILOT].includes(role)) {
    return RESOURCES.JOB
  }

  return null
}

const lookUpIntitialPage = (role) => {
  const resource = getDefaultResource(role)
  if (resource) {
    return resourceToPage[resource]
  }
  return NotFoundPage
}

const DashboardWithNavigation = withNavigation(() => {
  const { permissions, role } = usePermissions()

  return (
    <Switch>
      <ProtectedRoute
        path={['/applications', '/application']}
        component={ApplicationsManager}
        allowed={permissions.can('read', RESOURCES.PILOT_APPLICATION)}
      />

      <ProtectedRoute
        path={['/jobs', '/job']}
        component={JobsManager}
        allowed={permissions.can('read', RESOURCES.JOB)}
      />

      <ProtectedRoute
        path="/company"
        component={CompanyManager}
        allowed={permissions.can('read', RESOURCES.MY_COMPANY)}
      />

      <ProtectedRoute
        path={['/products', '/product']}
        component={ProductsManager}
        allowed={permissions.can('read', RESOURCES.PRODUCT)}
      />

      <ProtectedRoute
        path="/staff"
        component={StaffManager}
        allowed={permissions.can('read', RESOURCES.STAFF)}
      />

      <ProtectedRoute
        path="/legacy-companies"
        component={LegacyCompanyManager}
        allowed={permissions.can('read', RESOURCES.COMPANY)}
      />

      <ProtectedRoute
        path={['/pilots', '/pilot']}
        component={PilotsManager}
        allowed={permissions.can('read', RESOURCES.PILOT_DETAILS)}
      />

      <ProtectedRoute
        path="/my-pilot-info"
        component={PilotDetailsManager}
        allowed={permissions.can('read', RESOURCES.MY_PILOT_INFO)}
      />

      <Route exact path="/" component={lookUpIntitialPage(role)} />
      <Route path="/" component={NotFoundPage} />
    </Switch>
  )
})

const Dashboards = () => (
  <Switch>
    <Route path="/claim/:token" component={ClaimCompanyManager} />
    <DashboardWithNavigation />
  </Switch>
)

export { Dashboards }
